import { useState } from "react";
import { Play } from "lucide-react";
import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

const VideoCard = ({ title, testId, delay, videoId }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <Reveal delay={delay}>
      <figure
        className="group overflow-hidden rounded-3xl border border-amber-200/70 bg-white shadow-xl shadow-sky-900/5"
        data-testid={testId}
      >
        <div className="relative aspect-video overflow-hidden bg-slate-900">
          {playing ? (
            <iframe
              className="h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              data-testid={`${testId}-play`}
              onClick={() => setPlaying(true)}
              className="relative block h-full w-full"
              aria-label={title}
            >
              <img
                src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
                alt={title}
                loading="lazy"
                className="h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105"
                onError={(e) => {
                  e.currentTarget.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
                }}
              />
              <span className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-20 w-20 items-center justify-center rounded-full bg-amber-500 shadow-2xl shadow-amber-500/40 transition-transform duration-300 group-hover:scale-110">
                  <Play className="ms-1 h-8 w-8 fill-white text-white" />
                </span>
              </span>
            </button>
          )}
        </div>
        <figcaption className="flex items-center gap-3 px-6 py-5">
          <span className="h-8 w-1 rounded-full bg-gradient-to-b from-sky-500 to-amber-400" />
          <span className="font-heading text-base font-semibold text-slate-800 sm:text-lg">{title}</span>
        </figcaption>
      </figure>
    </Reveal>
  );
};

const Videos = () => {
  const { t } = useLanguage();

  return (
    <section id="videos" className="relative bg-sky-50/60 py-24 sm:py-32" data-testid="videos-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal className="text-center">
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-600">
            {t.videos.overline}
          </p>
          <h2 className="mx-auto mt-4 max-w-2xl font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            {t.videos.title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-600 sm:text-lg">{t.videos.subtitle}</p>
        </Reveal>
        <div className="mt-14 grid gap-8 lg:grid-cols-2">
          <VideoCard title={t.videos.video1} testId="video-card-1" delay={0} videoId="HHpq_LUzBbw" />
          <VideoCard title={t.videos.video2} testId="video-card-2" delay={0.12} videoId="IAZAZ_6Bo6M" />
        </div>
      </div>
    </section>
  );
};

export default Videos;
